exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".roundBtns{width:300%!important}.text--primary{color:\"primary\"}.v-small-dialog{width:24px!important;height:24px!important}", ""]);

// exports
